import { OrganisationContext, useWorkspace } from "@/context";
import { Outlet } from "react-router";

export const WorkspaceProvider = () => {
  const value = useWorkspace();
  return (
    <OrganisationContext value={value}>
      <Outlet />
    </OrganisationContext>
  );
};
